import React from 'react';
import { Grid, TextField } from '@mui/material';
import { Patient } from 'types/patient';

interface PatientObservationFormProps {
  patient: Patient;
  handleChange<K extends keyof Patient>(index: K, value: Patient[K]): void;
}

const PatientObservationForm: React.FC<PatientObservationFormProps> = ({ patient, handleChange }) => {
  return (
    <Grid container size={12} spacing={2}>
      <TextField
        fullWidth
        multiline
        minRows={2}
        label="Observação"
        value={patient.observation}
        onChange={e => handleChange('observation', e.target.value)}
      />
    </Grid>
  );
};

export default PatientObservationForm;
